export default __webpack_public_path__ + "static/media/gallery 4.7b5f1361.png";